/// <amd-module name="Feed/Legacy/Components/PackageFilterBar" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

import { FilterBar } from "VSSUI/FilterBar";
import { IPickListItem, PickListFilterBarItem } from "VSSUI/PickList";
import { KeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import { FILTER_CHANGE_EVENT, IFilterState } from "VSSUI/Utilities/Filter";
import { IHubViewState } from "VSSUI/Utilities/HubViewState";

import { PackageFilterBarConstants } from "Feed/Common/Constants/Constants";
import { FeedView, UpstreamSource } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { PackageFilterBarHelper } from "Feed/Legacy/Helpers/PackageFilterBarHelper";
import { upstreamSourceToPickListItem } from "Feed/Legacy/Helpers/UpstreamHelper";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export interface IPackageFilterBarProps {
    pageContext: IVssPageContext;
    selectedFeed: Feed;
    feedViews: FeedView[];
    hubState: IHubViewState;
}

export class PackageFilterBar extends React.PureComponent<IPackageFilterBarProps> {
    public componentWillMount(): void {
        this.props.hubState.filter.subscribe(this._handleFilterChanged, FILTER_CHANGE_EVENT);

        this._setViewFilter();
    }

    public componentWillUnmount(): void {
        this.props.hubState.filter.unsubscribe(this._handleFilterChanged, FILTER_CHANGE_EVENT);
    }

    public componentWillUpdate(): void {
        this._setViewFilter();
    }

    public render(): JSX.Element {
        return (
            <FilterBar {...this.props} className="packages-filterbar" filter={this.props.hubState.filter}>
                <KeywordFilterBarItem filterItemKey={PackageFilterBarConstants.KeywordFilterKey} />
                <PickListFilterBarItem
                    className={"view-dropdown"}
                    filterItemKey={PackageFilterBarConstants.ViewFilterKey}
                    getPickListItems={() => this.props.feedViews}
                    placeholder={PackageResources.FeedViewDropdown_Title}
                    getListItem={(item: FeedView) => PackageFilterBarHelper.getFeedViewPickListItem(item)}
                />
                {this.props.selectedFeed.upstreamEnabled && (
                    <PickListFilterBarItem
                        className={"upstream-sources-dropdown"}
                        filterItemKey={PackageFilterBarConstants.SourceFilterKey}
                        getPickListItems={() => this._getSourcesPickListItems()}
                        placeholder={PackageResources.FeedUpstreamDropdown_Title}
                        getListItem={(item: IPickListItem) => item}
                    />
                )}
            </FilterBar>
        );
    }

    private _setViewFilter() {
        if (this.props.selectedFeed.view) {
            const filterState: IFilterState = PackageFilterBarHelper.setFeedViewToFilterState(
                this.props.hubState.filter.getState(),
                this.props.selectedFeed.view
            );

            this.props.hubState.filter.setState(filterState, true /*suppressChangeEvent*/);
        }
    }

    private _getSourcesPickListItems(): IPickListItem[] {
        let pickListItems: IPickListItem[] = [];
        this.props.selectedFeed.upstreamSources.forEach((upstream: UpstreamSource) => {
            const pickListItem = upstreamSourceToPickListItem(this.props.pageContext, upstream);
            pickListItems.push(pickListItem);
        });
        pickListItems = pickListItems.sort((a: IPickListItem, b: IPickListItem) =>
            Utils_String.localeComparer(a.name, b.name)
        );
        pickListItems.unshift(PackageFilterBarHelper.localItem);
        return pickListItems;
    }

    private _handleFilterChanged = (): void => {
        const filterState = this.props.hubState.filter.getState();
        Actions.PackagesFilterBarChanged.invoke(filterState);
    };
}
